import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { type GlobalLoaderTheme } from "@shared/types/localTypes/globalLoader";

export const useGlobalLoaderStore = defineStore("globalLoader", () => {
  // State
  const _displayed = ref<boolean>(true);
  const _theme = ref<GlobalLoaderTheme>("platform");

  // Getters
  const isDisplayed = computed(() => _displayed.value);
  const theme = computed(() => _theme.value);

  // Actions
  const setTheme = (newTheme: GlobalLoaderTheme) => {
    _theme.value = newTheme;
  };

  const clearTheme = () => {
    setTheme("default");
  };

  const show = () => {
    _displayed.value = true;
  };

  const hide = () => {
    _displayed.value = false;
  };

  return {
    isDisplayed,
    theme,
    setTheme,
    clearTheme,
    show,
    hide,
  };
});
